"use client"
import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function CheckMarkIcon({ className }: Props) {
  const { t } = useLingui()

  return (
    <svg
      data-testid="check-mark-icon"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <title>{t`Check mark Icon`}</title>
      <path
        d="M13.3337 4L6.00033 11.3333L2.66699 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
